
import React from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Coffee } from "lucide-react";

const FloatingDonateButton = () => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="lg"
            className="fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 bg-orange-500 hover:bg-orange-600 z-50"
            asChild
          >
            <a
              href="https://www.buymeacoffee.com/trustay"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center"
            >
              <Coffee className="h-6 w-6 text-white" />
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left" className="mb-2">
          <p>贊助我們</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default FloatingDonateButton;
